<template>
  <ul class="referral-free-signup-note" data-testid="audience-cta-referral-note">
    <li>{{ $t('referral_upgrade_discount_note', { percent: REFERRAL_FIRST_SUBSCRIPTION_DISCOUNT_PERCENT }) }}</li>
    <li>{{ $t('referral_presenter_reward_note') }}</li>
  </ul>
</template>

<script>
const REFERRAL_FIRST_SUBSCRIPTION_DISCOUNT_PERCENT = 30

export default {
  data() {
    return { REFERRAL_FIRST_SUBSCRIPTION_DISCOUNT_PERCENT }
  },
}
</script>

<style lang="scss" scoped>
.referral-free-signup-note {
  margin: 8px 0 0;
  padding-inline-start: 1.25rem;
  list-style: disc;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: #666666;
  text-align: start;

  li + li {
    margin-top: 4px;
  }
}
</style>
